const PLACEHOLDER = /:[\w-]+/g;

export function resolveKey(key: string, args: Array<string>) {
  let index = 0;
  return key.replace(PLACEHOLDER, () => String(args[index++]));
}
